import { render, staticRenderFns } from "./tab_Settings.vue?vue&type=template&id=ab563c16&"
import script from "./tab_Settings.vue?vue&type=script&lang=js&"
export * from "./tab_Settings.vue?vue&type=script&lang=js&"
import style0 from "./tab_Settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports